(function () {
	/* Toggle content */
	$('.product-description-more').click(function (e) {
		e.preventDefault();
		$(this).closest('.product-description-short').next().show();
		$(this).closest('.product-description-short').hide();
	});

	$('.product-description-less').click(function (e) {
		e.preventDefault();
		$(this).closest('.product-description-full').prev().show();
		$(this).closest('.product-description-full').hide();
	});

	/* Toggle fields */
	$('.js-show-more').click(function (e) {
		e.preventDefault();
		$(this).siblings('input').removeClass('hidden');
		$(this).siblings('label').removeClass('hidden');
		$(this).remove();
	});
})();

/* Second floated product form */
class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute('data-product-url'))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
				this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]');

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll('script').forEach(oldScriptTag => {
			const newScriptTag = document.createElement('script');
			Array.from(oldScriptTag.attributes).forEach(attribute => {
				newScriptTag.setAttribute(attribute.name, attribute.value)
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `floated-${ sectionId }`);

		if (this.productElement.querySelectorAll('variant-selects')) {
			this.productElement.querySelectorAll('variant-selects').forEach(radio => {
				radio.dataset.originalSection = sectionId;
			});
		}

		if (this.productElement.querySelectorAll('variant-radios')) {
			this.productElement.querySelectorAll('variant-radios').forEach(radio => {
				radio.dataset.originalSection = sectionId;
			});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector('.product__text');
		if (text) text.remove();

		const shareButtons = this.productElement.querySelector('.share-buttons');
		if (shareButtons) shareButtons.remove();

		const rating = this.productElement.querySelector('.rating');
		if (rating) rating.remove();

		const tags = this.productElement.querySelector('.product-tags');
		if (tags) tags.remove();

		const description = this.productElement.querySelector('.product__description');
		if (description) description.remove();

		const advantages = this.productElement.querySelectorAll('.advantage');
		advantages.forEach(advantage => {
			advantage.remove();
		});

		const note = this.productElement.querySelector('.note');
		if (note) note.remove();

		const promoBanner = this.productElement.querySelector('.promo-banner');
		if (promoBanner) promoBanner.remove();

		const pickupAvailability = this.productElement.querySelector('pickup-availability');
		if (pickupAvailability) pickupAvailability.remove();

		const productModal = this.productElement.querySelector('product-modal');
		if (productModal) productModal.remove();

		const productForm = this.productElement.querySelector('floated-form');
		if (productForm) productForm.remove();

		const relatedProduct = this.productElement.querySelector('related-product');
		if (relatedProduct) relatedProduct.remove();

		const gift = this.productElement.querySelector('.customer');
		if (gift) gift.remove();

		const customLiquid = this.productElement.querySelector('.custom-liquid');
		if (customLiquid) customLiquid.remove();
	}

	showMoreFields() {
		$('.js-show-more').click(function (e) {
			e.preventDefault();
			$(this).siblings('input').removeClass('hidden');
			$(this).siblings('label').removeClass('hidden');
			$(this).remove();
		});
	}
}

customElements.define('floated-form', FloatedForm);

/* Variant List Item Click Handler */
document.addEventListener('DOMContentLoaded', function() {
	// Helper function to update visual state of variant list
	function updateVariantListVisualState(variantId) {
		const variantLists = document.querySelectorAll('.js-variant-list');
		variantLists.forEach(list => {
			list.querySelectorAll('.variant-list-item').forEach(listItem => {
				if (parseInt(listItem.getAttribute('data-variant-id')) === variantId) {
					listItem.classList.add('variant-list-item--active');
				} else {
					listItem.classList.remove('variant-list-item--active');
				}
			});
		});
	}

	// Listen for variant changes from pills/selects to update the variant list visual state
	// Use event delegation to work even after HTML is replaced
	document.addEventListener('change', function(e) {
		if (e.target.matches('input[name="id"]') && e.target.form && e.target.form.id.startsWith('product-form-')) {
			const variantId = parseInt(e.target.value);
			if (variantId) {
				updateVariantListVisualState(variantId);
			}
		}
	});

	// Use event delegation for variant list item clicks
	// This works even after the HTML is replaced by renderProductInfo()
	document.addEventListener('click', function(e) {
		const variantListItem = e.target.closest('.variant-list-item');
		if (!variantListItem) return;

		const variantList = variantListItem.closest('.js-variant-list');
		if (!variantList) return;

		e.preventDefault();

		const variantId = parseInt(variantListItem.getAttribute('data-variant-id'));
		if (!variantId) return;

		// Update visual state of variant list items
		variantList.querySelectorAll('.variant-list-item').forEach(listItem => {
			listItem.classList.remove('variant-list-item--active');
		});
		variantListItem.classList.add('variant-list-item--active');

		// Smooth scroll to top of page
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});

		// Get variant selector (radios or selects)
		const variantSelector = document.querySelector('variant-radios') || document.querySelector('variant-selects');
		if (!variantSelector) return;

		// Get variant data from JSON
		const variantDataScript = variantSelector.querySelector('[type="application/json"]');
		if (!variantDataScript) return;

		const variantData = JSON.parse(variantDataScript.textContent);
		const selectedVariant = variantData.find(v => v.id === variantId);
		if (!selectedVariant) return;

		// Update each option to match the selected variant
		if (variantSelector.tagName === 'VARIANT-RADIOS') {
			// Handle radio buttons (pills)
			const fieldsets = variantSelector.querySelectorAll('fieldset');
			selectedVariant.options.forEach((optionValue, index) => {
				if (fieldsets[index]) {
					const radio = fieldsets[index].querySelector(`input[value="${CSS.escape(optionValue)}"]`);
					if (radio && !radio.checked) {
						radio.checked = true;
						// Trigger change event only on the last option to avoid multiple updates
						if (index === selectedVariant.options.length - 1) {
							radio.dispatchEvent(new Event('change', { bubbles: true }));
						}
					}
				}
			});
		} else {
			// Handle select dropdowns
			const selects = variantSelector.querySelectorAll('select');
			selectedVariant.options.forEach((optionValue, index) => {
				if (selects[index]) {
					selects[index].value = optionValue;
					// Trigger change event only on the last select to avoid multiple updates
					if (index === selectedVariant.options.length - 1) {
						selects[index].dispatchEvent(new Event('change', { bubbles: true }));
					}
				}
			});
		}
	});
});
